import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import couponService from "../../../services/coupon.service";

const initialValues = {
  name: "",
  code: "",
  isActive: true,
  onlyApp: false,
};
const schema = Yup.object().shape({
  name: yupSchema.name,
  code: yupSchema.code,
  discount: yupSchema.discountPercent,
});
const form = [
  {
    _type: "textField",
    name: "name",
    label: "عنوان",
    autoFocus: true,
  },
  {
    _type: "textField",
    name: "code",
    label: "کد",
  },
  {
    _type: "textField",
    name: "discount",
    label: "تخفیف ٪",
    type: "number",
    inputProps: {
      min: 0,
      max: 100,
    },
  },
  {
    _type: "switch",
    name: "isActive",
    label: "فعال",
  },
  {
    _type: "switch",
    name: "onlyApp",
    label: "فقط اپلیکیشن",
  },
  {
    _type: "switch",
    name: "singleUse",
    label: "یکبارمصرف",
  },
];

export default function FormModalContent({ close, data, extra }) {
  const errorHandler = useErrorHandler();

  const handleSubmit = async (model, { setSubmitting }) => {
    let op;
    if (data?.id) {
      op = await couponService.editCoupon(data.id, model);
    } else {
      op = await couponService.createCoupon(model);
    }
    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };

  return (
    <DialogFormBuilder
      {...{
        close,
        name: "کدتخفیف",
        data,
        schema,
        initialValues: {
            ...initialValues,
            ...data
        },
        handleSubmit,
        form,
      }}
    />
  );
}
